import { useState } from "react";
import { PaperPlaneTilt } from "@phosphor-icons/react";
import { toast } from "sonner";
import useSEO from "@/hooks/useSEO";
import { PageHeader } from "@/components/PageHeader";
import { SUPPORT_EMAIL } from "@/lib/site";
import useT from "@/i18n";
import { breadcrumbLd, webPageLd } from "@/lib/seo";

const Field = ({ id, label, ...props }) => (
  <div>
    <label htmlFor={id} className="block text-xs tracking-[0.2em] uppercase text-slate-500 mb-2">{label}</label>
    {props.rows ? <textarea id={id} className="field" {...props} /> : <input id={id} className="field" {...props} />}
  </div>
);

export default function Contact() {
  const [f, setF] = useState({ name: "", email: "", subject: "", message: "" });
  const { t: T, lp } = useT();
  const t = T.contact;
  const path = "/contact";
  const title = t.seoTitle;
  const description = t.seoDesc;
  const crumbs = [{ name: t.crumb, path }];
  useSEO({ title, description, path, jsonLd: [webPageLd({ title, description, path: lp(path) }), breadcrumbLd(crumbs, T.crumbs.home, lp)] });

  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = (e) => {
    e.preventDefault();
    const body = `Name: ${f.name}\nEmail: ${f.email}\n\n${f.message}`;
    window.location.href = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(f.subject || t.defaultSubject)}&body=${encodeURIComponent(body)}`;
    toast.success(t.opening);
  };

  return (
    <div data-testid="contact-page">
      <PageHeader crumbs={crumbs} badge={t.badge} title={t.title} intro={t.intro} />
      <section className="max-w-3xl mx-auto safe-x sm:px-8 pb-16" aria-labelledby="contact-form-heading">
        <form onSubmit={submit} className="glass rounded-3xl p-6 sm:p-10 space-y-5" data-testid="contact-form">
          <h2 id="contact-form-heading" className="font-display text-2xl font-bold">{t.formTitle}</h2>
          <div className="grid sm:grid-cols-2 gap-5">
            <Field id="c-name" label={t.name} required value={f.name} onChange={set("name")} autoComplete="name" data-testid="contact-name-input" />
            <Field id="c-email" label={t.email} type="email" required value={f.email} onChange={set("email")} autoComplete="email" data-testid="contact-email-input" />
          </div>
          <Field id="c-subject" label={t.subject} value={f.subject} onChange={set("subject")} data-testid="contact-subject-input" />
          <Field id="c-message" label={t.message} rows={6} required value={f.message} onChange={set("message")} data-testid="contact-message-input" />
          <button type="submit" className="btn-primary w-full sm:w-auto" data-testid="contact-submit-btn"><PaperPlaneTilt size={18} weight="bold" aria-hidden="true" /> {t.send}</button>
        </form>
      </section>
    </div>
  );
}
